import { BoardMeetingWithDetails } from "@boark/shared/types/board-meeting-with-details";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  BoardMeetingForm,
  BoardMeetingFormValues,
} from "../../components/board-meeting-form";
import { Modal } from "../../components/modal";
import { useBoardMeetingMutation } from "../../queries/board-meeting";
import {
  fromDateTimeLocalValue,
  toDateTimeLocalValue,
  updateBoardMeeting,
} from "../../services/board-meeting";
import { navigateBack } from "../../utils/navigate-back";
import { recordIdToId } from "../../utils/record-id-to-id";

export function BoardMeetingEdit({
  meeting,
}: {
  meeting: BoardMeetingWithDetails;
}) {
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(false);
  const [formValues, setFormValues] = useState<BoardMeetingFormValues>({
    name: meeting.name,
    date: toDateTimeLocalValue(meeting.date),
    location: meeting.location ?? "",
    calledIds: meeting.called.map((user) => user.id),
  });

  const update = useBoardMeetingMutation(
    meeting.id,
    (values: BoardMeetingFormValues) =>
      updateBoardMeeting(meeting.id, {
        name: values.name.trim(),
        date: fromDateTimeLocalValue(values.date),
        location: values.location.trim() === "" ? null : values.location.trim(),
        calledIds: values.calledIds,
      }),
  );

  const closeModal = () => {
    navigateBack(navigate, `/admin/board-meeting/${recordIdToId(meeting.id)}`);
  };

  return (
    <Modal open onClose={() => closeModal()}>
      <BoardMeetingForm
        hasError={hasError}
        loading={update.isPending}
        values={formValues}
        onCancel={() => closeModal()}
        onChange={setFormValues}
        onSubmit={() => {
          update
            .mutateAsync(formValues)
            .then(() => closeModal())
            .catch(() => setHasError(true));
        }}
      />
    </Modal>
  );
}
